/* eslint-disable global-require */
if (!window.Intl || (Intl.NumberFormat && !Intl.NumberFormat.prototype.formatToParts)) {
  const IntlPolyfill = require('intl');
  Intl.NumberFormat = IntlPolyfill.NumberFormat;
}

if (!window.IntersectionObserver) {
  require('intersection-observer');
}
